module.exports = __webpack_public_path__ + "img/benjike1.e790f716.png";